import api from '../../plugins/axios'

const saved = JSON.parse(localStorage.getItem('complyops.auth') || '{}')

export default {
  namespaced: true,
  state: {
    accessToken: saved.accessToken || null,
    refreshToken: saved.refreshToken || null,
    tenantId: saved.tenantId || null,
    user: saved.user || null,
    tenant: saved.tenant || null
  },
  getters: {
    isAuthenticated: state => Boolean(state.accessToken)
  },
  mutations: {
    setSession (state, payload) {
      state.accessToken = payload.access_token
      state.refreshToken = payload.refresh_token || state.refreshToken
      state.user = payload.user || state.user
      state.tenant = payload.tenant || state.tenant
      state.tenantId = payload.tenant ? payload.tenant.id : state.tenantId

      localStorage.setItem('complyops.auth', JSON.stringify({
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        tenantId: state.tenantId,
        user: state.user,
        tenant: state.tenant
      }))
    },
    setUser (state, user) {
      state.user = user || state.user
      localStorage.setItem('complyops.auth', JSON.stringify({
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        tenantId: state.tenantId,
        user: state.user,
        tenant: state.tenant
      }))
    },
    clearSession (state) {
      state.accessToken = null
      state.refreshToken = null
      state.tenantId = null
      state.user = null
      state.tenant = null
      localStorage.removeItem('complyops.auth')
    }
  },
  actions: {
    async login ({ commit }, credentials) {
      const { data } = await api.post('/auth/login', credentials)
      commit('setSession', data)
    },
    async register ({ commit }, payload) {
      const { data } = await api.post('/auth/register', payload)
      commit('setSession', data)
    },
    async refresh ({ commit, state }) {
      const { data } = await api.post('/auth/refresh', { refresh_token: state.refreshToken })
      commit('setSession', data)
    },
    async logout ({ commit, state }) {
      try {
        await api.post('/auth/logout', { refresh_token: state.refreshToken })
      } finally {
        commit('clearSession')
      }
    },
    async updateMe ({ commit }, payload) {
      const { data } = await api.put('/me', payload)
      commit('setUser', data.user)
      return data
    }
  }
}
